export const AllStatus = [
    {value:"", label:"Selecione..."},
    {value:"1", label:"Reembolsável"},
    {value:"2", label:"Subvenção"},
    // {value:"refundable", label:"Reembolsável"},
    // {value:"notRefundable", label:"Não Reembolsável"},
    // {value:"both", label:"Ambos"},
]